var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{attrs:{"loop":"","src":_vm.round.video,"poster":_vm.round.preview,"preload":_vm.round.preview ? 'none' : 'metadata'},domProps:{"muted":_vm.muted},on:{"click":function($event){$event.stopPropagation();return _vm.roundClick.apply(null, arguments)}}}),(!_vm.playing)?_c('div',{staticClass:"playbtn"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }